import SettingField from 'components/Fields/ReduxForm/SettingField'
import {Field, reduxForm, isDirty} from 'redux-form'
import {connect} from 'react-redux'
import styles from './OutletForm.css'
import {askReactivateOutlet, askReactivateOutletWithoutPay} from 'actions/outletPages/list'
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField'
const validate = (values) => {
  const errors = {}
  const FIELD_REQUIRED_ERROR = 'This field is required'

  if (!values.name || values.name.trim() === '') {
    errors.name = FIELD_REQUIRED_ERROR
  }

  if (!values.address || values.address.trim() === '') {
    errors.address = FIELD_REQUIRED_ERROR
  }

  if (!values.phone) {
    errors.phone = FIELD_REQUIRED_ERROR
  }

  if (!values.city || values.city.trim() === '') {
    errors.city = FIELD_REQUIRED_ERROR
  }

  if (!values.province || values.province.trim() === '') {
    errors.province = FIELD_REQUIRED_ERROR
  }

  if (!values.postal || (!/^\d{5}$/.test(values.postal)) || values.postal.trim() === '') {
    errors.postal = FIELD_REQUIRED_ERROR
  }

  return errors
}

const renderOutletStatus = (outlet) => {
  if (outlet.is_deleted) {
    return <span className={styles['outlet-inactive']}>Expired</span>
  } else {
    return <span className={styles['outlet-active']}>Active</span>
  }
}

class OutletForm extends React.Component {
  render () {
    let {handleSubmit, editedOutlet, disableSaveOutletButton} = this.props
    return (<form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles['field-wrapper']}>
        {(editedOutlet) && <div className='row'>
          <div className='col-lg-12'>
            <p>Outlet Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{renderOutletStatus(editedOutlet)}</p>
          </div>
        </div>}
        <Field name='id' component='input' type='hidden' />
        <Field name='businessId' component='input' type='hidden' />
        <div className='row'>
          <div className='col-lg-12'>
            <div className='form-group'>
              <Field name='name' component={SettingField} placeholder='Outlet Name' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='form-group'>
              <Field name='address' component={SettingField} placeholder='Address' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='form-group'>
              <Field
                component={PhoneNumberField}
                name='phone'
                type='tel'
                placeholder='812'
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-4'>
            <div className='form-group'>
              <Field name='city' component={SettingField} placeholder='City' />
            </div>
          </div>
          <div className='col-md-4'>
            <div className='form-group'>
              <Field name='province' component={SettingField} placeholder='State' />
            </div>
          </div>
          <div className='col-md-4'>
            <div className='form-group'>
              <Field
                name='postal'
                component={SettingField}
                placeholder='Zip'
                maxLength='5'
                positiveNumberOnly
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <span className='pull-left'>
          {editedOutlet && editedOutlet.is_deleted && <button className='btn btn-primary' type='button' onClick={this._onClickReactivateOutlet}>Reactivate</button>}
        </span>
        <span className='pull-right'>
          <button className='btn btn-default' type='button' style={{'margin-right': '10px'}} onClick={this._onClickCancel}>
            Cancel
          </button>
          <button className='btn btn-primary' type='submit' disabled={disableSaveOutletButton}>
            Save
          </button>
        </span>
      </div>
    </form>)
  }

  _onClickCancel = () => {
    this.props.onClickCancel()
  }

  _onClickReactivateOutlet = () => {
    let {editedOutlet, dispatch, outletSlots, usedOutletSlots} = this.props
    if (outletSlots > usedOutletSlots) {
      dispatch(askReactivateOutletWithoutPay(editedOutlet))
    } else {
      dispatch(askReactivateOutlet(editedOutlet))
    }
  }
}

OutletForm.propTypes = {
  onClickCancel: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func,
  isDirtyForm: React.PropTypes.bool,
  editedOutlet: React.PropTypes.object
}

const mapForm = {
  form: 'outlet',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

function mapStateTopProps (state) {
  const {outletSlots, usedOutletSlots} = state.outletPages.list
  return {
    isDirtyForm: isDirty('outlet')(state),
    editedOutlet: state.outletPages.list.outletDetail,
    disableSaveOutletButton: state.outletPages.list.disableSaveOutletButton,
    outletSlots,
    usedOutletSlots
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateTopProps, mapDispatchToProps)(reduxForm(mapForm)(OutletForm))



// WEBPACK FOOTER //
// ./app/pages/Outlets/List/OutletDetail/OutletForm/OutletForm.js